<template>
  <div class="car-recommend">
    <div class="car-recommend__container">
      <!-- 标题栏 -->
      <div class="car-recommend__header">
        <div class="car-recommend__title-group">
          <h2 class="car-recommend__title">Top Cars</h2>
          <div class="car-recommend__switcher" v-show="deviceType !== 'mobile' && !loading && cars.length > 0">
            <div class="car-recommend__switch car-recommend__switch--left" @click="prevPage" :style="{ opacity: currentPage === 0 ? 0.5 : 1 }">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                fill="none">
                <path
                  d="M1.81151 6L5.78094 1.46355C6.07302 1.12975 6.07302 0.584148 5.78094 0.250349C5.48887 -0.0834497 5.01146 -0.0834497 4.71938 0.250349L0.218581 5.39407C0.145855 5.47718 0.0907245 5.5737 0.0543615 5.67693C-0.00898042 5.8579 -0.0171914 6.05898 0.0309015 6.24532C0.0379395 6.27213 0.0461505 6.2976 0.0543615 6.32441C0.0907245 6.42764 0.145855 6.52416 0.218581 6.60727L4.71821 11.7497C5.01028 12.0835 5.48769 12.0835 5.77977 11.7497C6.07185 11.4159 6.07185 10.8702 5.77977 10.5364L1.81151 6Z"
                  fill="white" />
              </svg>
            </div>
            <div class="car-recommend__switch car-recommend__switch--right" @click="nextPage" :style="{ opacity: currentPage === maxPage ? 0.5 : 1 }">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12"
                fill="none">
                <path
                  d="M4.18849 6L0.219058 1.46355C-0.073019 1.12975 -0.073019 0.584148 0.219058 0.250349C0.511134 -0.0834497 0.988545 -0.0834497 1.28062 0.250349L5.78142 5.39407C5.85414 5.47718 5.90928 5.5737 5.94564 5.67693C6.00898 5.8579 6.01719 6.05898 5.9691 6.24532C5.96206 6.27213 5.95385 6.2976 5.94564 6.32441C5.90928 6.42764 5.85414 6.52416 5.78142 6.60727L1.28179 11.7497C0.989717 12.0835 0.512307 12.0835 0.22023 11.7497C-0.0718465 11.4159 -0.0718465 10.8702 0.22023 10.5364L4.18849 6Z"
                  fill="white" />
              </svg>
            </div>
          </div>
        </div>
        <a v-if="!loading && cars.length > 0" class="car-recommend__view-more" :href="getHrefForAll()">
          <span>View More</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10"
            fill="none">
            <path
              d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z"
              fill="#e2372d" />
          </svg>
        </a>
        <div v-else class="car-recommend__view-more-skeleton"></div>
      </div>

      <!-- 骨架屏 -->
      <div v-if="loading || cars.length === 0" class="car-recommend__skeleton">
        <div class="car-recommend__cards-wrapper">
          <div class="car-recommend__cards"
            :class="{'car-recommend__cards--mobile': deviceType === 'mobile'}">
            <div v-for="n in (deviceType === 'mobile' ? 3 : 3)" :key="`skeleton-${n}`" class="car-recommend__card car-recommend__card--skeleton">
              <div class="car-recommend__card-img-wrapper">
                <div class="car-recommend__skeleton-img"></div>
                <div class="car-recommend__card-logo-circle car-recommend__skeleton-logo"></div>
              </div>
              <div class="car-recommend__card-content">
                <div class="car-recommend__skeleton-title"></div>
                <div class="car-recommend__skeleton-subtitle"></div>
                <div class="car-recommend__card-info-grid">
                  <div class="car-recommend__card-info-item">
                    <div class="car-recommend__skeleton-icon"></div>
                    <div class="car-recommend__skeleton-text"></div>
                  </div>
                  <div class="car-recommend__card-info-item">
                    <div class="car-recommend__skeleton-icon"></div>
                    <div class="car-recommend__skeleton-text"></div>
                  </div>
                  <div class="car-recommend__card-info-item">
                    <div class="car-recommend__skeleton-icon"></div>
                    <div class="car-recommend__skeleton-text"></div>
                  </div>
                </div>
                <div class="car-recommend__card-footer">
                  <div class="car-recommend__skeleton-price"></div>
                  <div class="car-recommend__skeleton-arrow"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 实际内容 -->
      <div v-else class="car-recommend__cards-wrapper">
        <div class="car-recommend__cards"
          :class="{'car-recommend__cards--mobile': deviceType === 'mobile'}">
          <div v-for="(car, index) in displayedCars" :key="`recommend-${index}`" class="car-recommend__item">
            <a class="car-recommend__card"
              :href="getHrefForDetail(car)">

            <div class="car-recommend__card-img-wrapper">
              <img :src="car.image" class="car-recommend__card-img" :alt="car.model">
              <div class="car-recommend__card-logo-circle">
                <img :src="car.logo" class="car-recommend__card-logo" :alt="car.brand">
              </div>
            </div>

            <div class="car-recommend__card-content">
              <h3 class="car-recommend__card-title">{{ car.model }}</h3>
              <p class="car-recommend__card-subtitle">{{ car.brand }}</p>

              <div class="car-recommend__card-info-grid">
                <div class="car-recommend__card-info-item">
                  <img src="@/assets/calendar.svg" class="car-recommend__card-info-icon" alt="year">
                  <span>{{ car.marketTime? car?.marketTime?.replace('-', '.') : car?.year }}</span>
                </div>
                <div class="car-recommend__card-info-item">
                  <img src="@/assets/car-type.svg" class="car-recommend__card-info-icon" alt="type">
                  <span>{{ car.bodyType }}</span>
                </div>
                <div class="car-recommend__card-info-item">
                  <img src="@/assets/body-type.svg" class="car-recommend__card-info-icon"
                    alt="purpose">
                  <span>{{ car.category }}</span>
                </div>
              </div>

              <div class="car-recommend__card-footer">
                <span class="car-recommend__card-price">{{ car.price }}</span>
                <div class="car-recommend__card-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10"
                    fill="none">
                    <path
                      d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z"
                      fill="white" />
                  </svg>
                </div>
              </div>
            </div>
            </a>

            <AdComponent v-if="deviceType === 'mobile' && index === 0 && $global.isValidAdConfig(adsensConfig?.home_2)"
              ref="ads-home-2-mobile"
              class="ads-insert-full padding-right-with-full" :ads="adsensConfig?.home_2"
              :showDebug="showDebug" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import AdComponent from '@/pages/components/AdComponent.vue'
export default {
  name: 'CarRecommend',
  mixins: [adMixin, adTrackingMixin],
  components: {
    AdComponent
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      originalTopCars: 'originalTopCars',
      topCarsLoaded: 'topCarsLoaded',
      adsensConfig: 'adsensConfig',
      showDebug: 'showDebug',
      domainConfig: 'domainConfig'
    }),
    // 从 Vuex 获取并处理车辆数据
    processedCars () {
      if (!Array.isArray(this.originalTopCars) || this.originalTopCars.length === 0) {
        return [];
      }

      // 处理API返回的数据，并限制最多显示8条
      return this.originalTopCars.slice(0, 8).map(item => {
        // 从photos字段提取第一张图片作为封面
        const photos = item.photos ? item.photos.split(',') : [];
        const firstPhoto = photos.length > 0 ? photos[0] : '';

        // 返回处理后的数据，映射字段名称
        return {
          id: item.id,
          model: item.name, // API中是name字段，映射为model
          brand: item.brand,
          logo: item.logoUrl, // 使用默认logo，因为API中没有提供
          marketTime: item.marketTime,
          year: item.year || item.marketTime?.substring(0, 4) || '-',
          category: item.purpose || '-', // 使用purpose字段作为category
          bodyType: item.type || '-', // 使用type字段作为bodyType
          price: this.formatPrice(item.leastPrice, item.mostPrice) || item.price || '-',
          image: item.cover || firstPhoto, // 使用cover字段，如果没有则使用firstPhoto
          speedValue: item.accelerationTime ? `${item.accelerationTime}s` : '-' // 添加's'后缀
        };
      });
    },
    // 是否应该显示导航箭头（PC模式且数据超过3条）
    shouldShowArrows () {
      return (this.deviceType === 'desktop' || this.deviceType === 'pc') && this.cars.length > 3;
    },
    // 计算最大页码
    maxPage () {
      if (this.cars.length <= 3) return 0;
      return Math.ceil(this.cars.length / 3) - 1;
    },
    // 当前页应该显示的卡片
    displayedCars () {
      // 移动端显示前3个卡片，用于纵向排列
      if (this.deviceType === 'mobile') {
        return this.cars.slice(0, 3);
      }
      // PC端根据当前页显示3个卡片
      const startIndex = this.currentPage * 3;
      return this.cars.slice(startIndex, startIndex + 3);
    }
  },
  data () {
    return {
      cars: [],
      loading: true,
      error: null,
      currentPage: 0 // 当前显示的页码，0表示第一页
    }
  },
  mounted () {
    this.fetchTopCars();
  },
  watch: {
    // 监听处理后的数据变化，更新本地cars数组
    processedCars: {
      immediate: true,
      handler (newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.cars = newVal;
          this.loading = false;
          // 重置当前页码
          this.currentPage = 0;
        } else if (!this.loading) {
          // 如果数据加载完成但为空，也停止loading
          this.loading = false;
        }
      }
    }
  },
  methods: {
    // 获取推荐车辆数据
    async fetchTopCars () {
      if (this.topCarsLoaded && Array.isArray(this.originalTopCars) && this.originalTopCars.length > 0) {
        return;
      }

      this.loading = true;
      try {
        const themeFilters = this.domainConfig?.themeFilters || {};
        const webIndex = this.domainConfig?.webIndex || 1;

        const params = {
          ...themeFilters,
          webIndex,
          pageSize: 20 // 获取足够的数据用于翻页
        };
        const res = await this.$global.server.getRecommendedTopCars(params);
        if (res.code === 200) {
          this.$store.commit('SET_ORIGINAL_TOP_CARS', res.data || []);
        }
      } catch (error) {
        console.error('[CarRecommend] Error fetching top cars:', error);
      } finally {
        this.loading = false;
      }
    },
    // 切换到上一页
    prevPage () {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },
    // 切换到下一页
    nextPage () {
      if (this.currentPage < this.maxPage) {
        this.currentPage++;
      }
    },
    // Format price display
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },
    // Generate href for "View All" link
    getHrefForAll () {
      const currentChannel = this.$route.params.channel;
      const queryString = new URLSearchParams(this.$route.query).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      if (currentChannel) {
        return `/${currentChannel}/car-list${fullQueryString}`;
      }
      return `/car-list${fullQueryString}`;
    },

    // Generate href for car detail page
    getHrefForDetail (car) {
      if (!car || !car.id) {
        return 'javascript:void(0);';
      }
      const currentChannel = this.$route.params.channel;
      const formattedName = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      const queryString = new URLSearchParams(this.$route.query).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      if (currentChannel) {
        return `/${currentChannel}/cars/${formattedName}/${car.id}${fullQueryString}`;
      }
      return `/cars/${formattedName}/${car.id}${fullQueryString}`;
    }
  }
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.car-recommend {
	background: #000;
	padding: rem(60) rem(180);
	width: 100%;
	box-sizing: border-box;

	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(20);
	}

	&__title-group {
		display: flex;
		align-items: center;
		gap: rem(20);
	}

	&__title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(24);
		font-weight: 800;
		margin: 0;
	}

	&__switcher {
		display: flex;
		gap: rem(12);
	}

	&__switch {
		width: rem(24);
		height: rem(24);
		background: #e2372d;
		border-radius: rem(8);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			opacity: 0.8;
		}
	}

	&__view-more {
		display: flex;
		align-items: center;
		gap: rem(12);
		text-decoration: none;

		span {
			color: #e2372d;
			font-family: 'Inter-ExtraBold', sans-serif;
			font-size: rem(14);
			font-weight: 800;
		}

		&:hover {
			opacity: 0.8;
		}
	}

	&__cards-wrapper {
		width: 100%;
	}

	&__cards {
		display: flex;
		gap: rem(20);
		width: 100%;

		&--mobile {
			overflow-x: auto;
			&::-webkit-scrollbar {
				display: none;
			}
		}
	}

	&__item {
		display: contents;
	}

	&__card {
		flex: 1;
		min-width: 0;
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		padding: 0;
		text-decoration: none;
		transition: all 0.3s ease;
		display: flex;
		flex-direction: column;
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);

		&:hover {
			transform: translateY(-5px);
		}
	}

	&__card-img-wrapper {
		position: relative;
		padding: rem(8);
		height: rem(200);
	}

	&__card-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.2);
	}

	&__card-logo-circle {
		position: absolute;
		top: rem(9);
		left: rem(9);
		width: rem(40);
		height: rem(40);
		background: #fff;
		border-radius: rem(16) 0 rem(12) 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: rem(4);
		box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.32);
	}

	&__card-logo {
		width: 80%;
		height: 80%;
		object-fit: contain;
	}

	&__card-content {
		padding: rem(12) rem(20) rem(20);
		display: flex;
		flex-direction: column;
		gap: rem(12);
	}

	&__card-title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(20);
		font-weight: 800;
		margin: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__card-subtitle {
		color: rgba(255, 255, 255, 0.7);
		font-size: rem(12);
		overflow: hidden;
		color: #fff;
		text-overflow: ellipsis;
		font-family: Inter;
		font-style: normal;
		font-weight: 400;
		line-height: rem(12); /* 100% */
	}

	&__card-info-grid {
		display: flex;
		gap: rem(8);
		margin-top: rem(4);
	}

	&__card-info-item {
		flex: 1;
		background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 100%);
		border-radius: rem(12);
		border: 1px solid rgba(255, 255, 255, 0.1);
		padding: rem(12);
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: rem(12);

		span {
			color: #ffffff;
			font-family: 'Inter-Medium', sans-serif;
			font-size: rem(12);
			font-weight: 500;
			text-align: center;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			width: 100%;
		}
	}

	&__card-info-icon {
		width: rem(20);
		height: rem(20);
	}

	&__card-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: rem(12);
	}

	&__card-price {
		color: #e2372d;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(16);
		font-weight: 800;
	}

	&__card-arrow {
		display: flex;
	}

	// 骨架屏样式
	&__skeleton {
		width: 100%;
	}

	&__view-more-skeleton {
		width: rem(100);
		height: rem(24);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__card--skeleton {
		pointer-events: none;
		cursor: default;
	}

	&__skeleton-img {
		width: 100%;
		height: 100%;
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(16);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-logo {
		background: rgba(255, 255, 255, 0.1) !important;
		animation: skeleton-loading 1.5s ease-in-out infinite;
		img {
			display: none;
		}
	}

	&__skeleton-title {
		width: 60%;
		height: rem(20);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-subtitle {
		width: 40%;
		height: rem(12);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		margin-top: rem(4);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-icon {
		width: rem(20);
		height: rem(20);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-text {
		width: 80%;
		height: rem(12);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		margin-top: rem(8);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-price {
		width: rem(80);
		height: rem(16);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-arrow {
		width: rem(24);
		height: rem(10);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}
}

@keyframes skeleton-loading {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.4;
	}
	100% {
		opacity: 1;
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-recommend {
		padding: rem(60) rem(180);
		&__header {
			padding-right: 0;
		}
		&__cards {
			padding-right: 0;
		}
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.car-recommend {
		padding: rem(40) 0 rem(60) rem(16);
		&__header {
			padding-right: rem(16);
		}
		&__cards {
			padding-right: rem(20);
			flex-direction: column;
			gap: rem(20);
		}
		&__card {
			width: 100%;
			flex-shrink: 0;
		}
	}
}
</style> 
